module.exports = __webpack_public_path__ + "static/media/5.4b6a6111.jpg";